import { Trans } from 'react-i18next'
import LocalPlayIcon from '@mui/icons-material/LocalPlay'
import { useState } from 'react'
import { Link } from 'settle-ui/components/Link/Link'
import { MessageCard } from 'settle-ui/components/MessageCard/MessageCard'
import { ViewPromoCodeDialog } from 'routes/dialogs/ViewPromoCodeDialog/ViewPromoCodeDialog'
import { useAppliedPromoCodeContext } from 'routes/hooks/useAppliedPromoCodeContext/useAppliedPromoCodeContext'
import { withPromoAppliedSubscription } from './hocs/withPromoAppliedSubscription'
import type { PromoCodeMessageProps } from './PromoCodeMessage.types'

export const PromoCodeMessage: Settle.FC<PromoCodeMessageProps> = ({ sx, type, ...props }) => {
  const [viewPromoCodeDialogOpen, setViewPromoCodeDialogOpen] = useState(false)
  const { promoCode } = useAppliedPromoCodeContext()

  const message =
    type === 'inApp' ? (
      <Trans
        i18nKey="promoCodeApplicationMessage::inApp"
        components={{
          details: <Link sx={{ fontSize: 'inherit' }} onClick={() => setViewPromoCodeDialogOpen(true)} />,
        }}
        values={{ name: promoCode?.displayName }}
      />
    ) : (
      <Trans i18nKey="promoCodeApplicationMessage::onboarding" values={{ name: promoCode?.displayName }} />
    )

  return (
    <>
      <MessageCard
        data-testid="promo-code-message"
        variant="upsell"
        margin="none"
        {...props}
        sx={sx}
        slots={{ left: <LocalPlayIcon color="secondary" />, content: message }}
      />
      <ViewPromoCodeDialog open={viewPromoCodeDialogOpen} onClose={() => setViewPromoCodeDialogOpen(false)} />
    </>
  )
}

export const PromoCodeMessageSubscribed = withPromoAppliedSubscription(PromoCodeMessage)
